import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "grpc/txauth/client/txauth_client.proto" (package "grpc.txauth.client", syntax proto3)
// tslint:disable
import { TxAuthClient } from "./txauth_client_pb";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service grpc.txauth.client.TxAuthClient
 */

export var TxAuthClientClient = /*#__PURE__*/function () {
  function TxAuthClientClient(_transport) {
    _classCallCheck(this, TxAuthClientClient);

    this._transport = _transport;
    this.typeName = TxAuthClient.typeName;
    this.methods = TxAuthClient.methods;
    this.options = TxAuthClient.options;
  }
  /**
   * *
   * // TBD
   * Ошибки передаются посредством grpc-exceptions.
   *
   * @generated from protobuf rpc: SubscribeRenew(grpc.txauth.client.SubscribeRenewRequest) returns (stream grpc.txauth.client.SubscribeRenewResponse);
   */


  _createClass(TxAuthClientClient, [{
    key: "subscribeRenew",
    value: function subscribeRenew(input, options) {
      var method = this.methods[0],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("serverStreaming", this._transport, method, opt, input);
    }
    /**
     * *
     *  Метод получения URI для oauth-авторизации.
     *  Ошибки передаются посредством grpc-exceptions.
     *
     * @generated from protobuf rpc: OAuthLogin(grpc.txauth.client.OAuthLoginRequest) returns (grpc.txauth.client.OAuthLoginResponse);
     */

  }, {
    key: "oAuthLogin",
    value: function oAuthLogin(input, options) {
      var method = this.methods[1],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * *
     *  Метод получения провайдеров oauth-авторизации, привязанных к клиентской учётной записи.
     *  В заголовке Authorization ожидается клиентский jwt-токен.
     *  Ошибки передаются посредством grpc-exceptions.
     *
     * @generated from protobuf rpc: GetOAuthConnections(grpc.txauth.client.GetOAuthConnectionsRequest) returns (grpc.txauth.client.GetOAuthConnectionsResponse);
     */

  }, {
    key: "getOAuthConnections",
    value: function getOAuthConnections(input, options) {
      var method = this.methods[2],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * *
     *  Метод привязки провайдера oauth-авторизации к клиентской учётной записи.
     *  В заголовке Authorization ожидается клиентский jwt-токен.
     *  Ошибки передаются посредством grpc-exceptions.
     *
     * @generated from protobuf rpc: OAuthConnect(grpc.txauth.client.OAuthConnectRequest) returns (grpc.txauth.client.OAuthConnectResponse);
     */

  }, {
    key: "oAuthConnect",
    value: function oAuthConnect(input, options) {
      var method = this.methods[3],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * *
     *  Метод отвязки провайдера oauth-авторизации от клиентской учётной записи.
     *  В заголовке Authorization ожидается клиентский jwt-токен.
     *  Ошибки передаются посредством grpc-exceptions.
     *
     * @generated from protobuf rpc: OAuthDisconnect(grpc.txauth.client.OAuthDisconnectRequest) returns (grpc.txauth.client.OAuthDisconnectResponse);
     */

  }, {
    key: "oAuthDisconnect",
    value: function oAuthDisconnect(input, options) {
      var method = this.methods[4],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     *
     *  Метод шифрования абстрактных данных. Используются ключи, принадлежащие клиенту.
     *  В заголовке Authorization ожидается клиентский jwt-токен.
     *  Ошибки передаются посредством grpc-exceptions.
     *
     * @generated from protobuf rpc: Encode(grpc.txauth.client.EncodeRequest) returns (grpc.txauth.client.EncodeResponse);
     */

  }, {
    key: "encode",
    value: function encode(input, options) {
      var method = this.methods[5],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     *
     *  Метод дешифрования абстрактных данных. Используются ключи, принадлежащие клиенту.
     *  В заголовке Authorization ожидается клиентский jwt-токен.
     *  Ошибки передаются посредством grpc-exceptions.
     *
     * @generated from protobuf rpc: Decode(grpc.txauth.client.DecodeRequest) returns (grpc.txauth.client.DecodeResponse);
     */

  }, {
    key: "decode",
    value: function decode(input, options) {
      var method = this.methods[6],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     *
     *  Запрос QR-кода для авторизации посредством мобильного устройства.
     *  Метод предназначен для использования только со стационарных устройств.
     *  Ошибки передаются посредством grpc-exceptions.
     *
     * @generated from protobuf rpc: GetQRCode(grpc.txauth.client.GetQRCodeRequest) returns (grpc.txauth.client.GetQRCodeResponse);
     */

  }, {
    key: "getQRCode",
    value: function getQRCode(input, options) {
      var method = this.methods[7],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     *
     *  Запрос клиентского jwt-токена по идентификатору QR-сессии.
     *  Должен периодически вызываться пока не будет получен терминальный статус или терминальная ошибка.
     *  Метод предназначен для использования только со стационарных устройств.
     *  Ошибки передаются посредством grpc-exceptions.
     *
     * @generated from protobuf rpc: AuthByQRSession(grpc.txauth.client.AuthByQRSessionRequest) returns (grpc.txauth.client.AuthByQRSessionResponse);
     */

  }, {
    key: "authByQRSession",
    value: function authByQRSession(input, options) {
      var method = this.methods[8],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     *
     *  Запрос о деталях устройства, с которого идёт попытка авторизации по QR-коду.
     *  Метод предназначен для использования только с мобильных устройств.
     *  В заголовке Authorization ожидается клиентский jwt-токен.
     *  Ошибки передаются посредством grpc-exceptions.
     *
     * @generated from protobuf rpc: GetQRSessionDetails(grpc.txauth.client.GetQRSessionDetailsRequest) returns (grpc.txauth.client.GetQRSessionDetailsResponse);
     */

  }, {
    key: "getQRSessionDetails",
    value: function getQRSessionDetails(input, options) {
      var method = this.methods[9],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     *
     *  Подтверждение авторизации стационарного устройства по QR-коду.
     *  Метод предназначен для использования только с мобильных устройств.
     *  В заголовке Authorization ожидается клиентский jwt-токен.
     *  Ошибки передаются посредством grpc-exceptions.
     *
     * @generated from protobuf rpc: ApproveQRSession(grpc.txauth.client.ApproveQRSessionRequest) returns (grpc.txauth.client.ApproveQRSessionResponse);
     */

  }, {
    key: "approveQRSession",
    value: function approveQRSession(input, options) {
      var method = this.methods[10],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     *
     *  Метод для заполнения персональных данных анонимного клиента.
     *  Персональные данные будут привязаны к устройству клиента.
     *  В ответе будет отдан обновленный токен с заполненными данными.
     *  В заголовке Authorization ожидается клиентский jwt-токен.
     *  Ошибки передаются посредством grpc-exceptions.
     *
     * @generated from protobuf rpc: ComingOut(grpc.txauth.client.ComingOutRequest) returns (grpc.txauth.client.ComingOutResponse);
     */

  }, {
    key: "comingOut",
    value: function comingOut(input, options) {
      var method = this.methods[11],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
  }]);

  return TxAuthClientClient;
}();